import React from "react";
import { useParams } from "react-router-dom";
import ReactPlayer from "react-player";

function YouTubePlayerPage() {
  const { v } = useParams();

  return (
    <div style={{width:"100%",height:"100%", overflow: "hidden"}}>
      {v ? (
        <ReactPlayer
          url={`https://www.youtube.com/watch?v=${v}`}
          controls
          playing
          width="100%"
          height="100%"
        />
      ) : (
        <p style={{ color: "white" }}>No video key provided.</p>
      )}
    </div>
  );
}

export default YouTubePlayerPage;
